import { TABLE_ACTION, defaultColDef, defaultColActionDef, CellParams } from '@qrios/frontend-library';

import { AppsStatusMapper } from './appsStatusMapper';

import { nortadaLogger } from '../../../../../common/logger';
import { TOGGLE_STATUS } from '../../../../../common/status/interfaces';
import { StatusMapper } from '../../../../../common/status/statusMapper';
import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';

export const renderAppDebugMode = (debugEnabled: boolean) => (
  <StatusMapper status={debugEnabled ? TOGGLE_STATUS.ENABLED : TOGGLE_STATUS.DISABLED} />
);
export const renderStatus = (status: string) => (
  <AppsStatusMapper status={status === TOGGLE_STATUS.ENABLED ? TOGGLE_STATUS.ENABLED : TOGGLE_STATUS.DISABLED} />
);

export const columns = [
  {
    ...defaultColDef,
    flex: 1,
    field: 'shortcode',
    headerName: 'Shortcode',
    sortable: true
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'appId',
    headerName: 'Id',
    sortable: true
  },
  {
    ...defaultColDef,
    flex: 2,
    minWidth: 150,
    field: 'appUrl',
    headerName: 'URL',
    sortable: true
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'debugEnabled',
    headerName: 'Debug mode',
    minWidth: 150,
    sortable: true,
    renderCell: (cell: CellParams) => {
      if (typeof cell.value === 'boolean') {
        return renderAppDebugMode(cell.value);
      }
      return nortadaLogger.critical(
        `Error while rendering "Debug mode" tabel cell in USSD Apps.
        Received ${typeof cell.value} type but need to be boolean.`
      );
    }
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'status',
    headerName: 'Status',
    minWidth: 120,
    sortable: true,
    renderCell: (cell: CellParams) => {
      if (typeof cell.value === 'string') {
        return renderStatus(cell.value);
      }
      return nortadaLogger.critical(
        `Error while rendering "Status" tabel cell in USSD Apps.
        Received ${typeof cell.value} type but need to be string.`
      );
    }
  },
  {
    ...defaultColActionDef([TABLE_ACTION.EDIT, TABLE_ACTION.OPEN]),
    minWidth: 85
  },
  predefinedColumns.date({ field: 'createDate', hide: true })
];
